import { FileText } from 'lucide-react'
import { EmptyState } from 'src/shared/components/EmptyState'
import { useLocalization } from 'src/shared/hooks/useLocalization'

export const VerifyProofsEmptyState = ({
  isShareOrder,
  withCard = true,
}: {
  isShareOrder?: boolean
  withCard?: boolean
}) => {
  const { t } = useLocalization()

  return (
    <EmptyState
      icon={<FileText className="w-9 h-9" />}
      withCard={withCard}
      title={t(
        'Your factory proofs are on the way',
        'Dina korrekturer är på väg'
      )}
      description={
        isShareOrder
          ? t(
              'Nothing to do right now — the team is preparing proofs that show exactly how your design will look. We’ll email you when they’re ready to review.',
              'Inget mer att göra just nu — teamet tar fram korrekturer som visar exakt hur din design kommer att se ut. Vi mejlar dig när de är klara att granska.'
            )
          : t(
              'Nothing to do right now — sit tight while we prepare proofs that show exactly how your design will look. We’ll email you when they’re ready to review.',
              'Inget mer att göra just nu — sitt still medan vi tar fram korrekturer som visar exakt hur din design kommer att se ut. Vi mejlar dig när de är klara att granska.'
            )
      }
    />
  )
}
